<template>
  <v-select
    outlined
    dense
    hide-details
    v-model="selectedCurrency"
    :items="formattedCurrencies"
    :label="label"
    item-text="name"
    return-object
    cache-items
    flat
    :menu-props="{offsetY: true }"
    required
    hide-no-data
  >
    <template v-slot:selection="data">
      <span>{{ data.item.name }} ({{ data.item.code }})</span>
    </template>
    <template v-slot:item="data">
      <template v-if="data.item">
        <span>{{ data.item.name }} ({{ data.item.code }})</span>
      </template>
    </template>
  </v-select>
</template>

<script>
import currencies from '@/data/currencies';
import { set } from 'lodash';

export default {
  name: "CurrencySelect",
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: "Currency"
    },
    only: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedCurrency: { 
        name: 'British Pound Sterling',
        code: 'GBP', 
        symbol: '£'
      }
    };
  },
  methods:{
    selectByCode(code) {
      let currency = this.formattedCurrencies.find(currency => currency.code === code);
      this.selectedCurrency = currency;
      return this.selectedCurrency;
    },
    selectDefault(){
      return this.selectedCurrency
    }
  },
  computed: {
    formattedCurrencies() {
      return Object.keys(currencies).map(key => ({
        name: currencies[key].name,
        code: key,
        symbol: currencies[key].symbol
      })).filter(currency => {
        if (this.only.length === 0) {
          return true;
        }
        
        return this.only.includes(currency.code);
      }).filter(currency => {
        // only allow euro gbp and usd
        return ['EUR', 'GBP', 'USD'].includes(currency.code);
      });
    },

    
  },
  watch: {
    selectedCurrency(newValue) {
      setTimeout(() => {
        if(this.selectedCurrency && this.selectedCurrency.code) {
          this.$emit("input", this.selectedCurrency);
        }
      }, 10);
    },
    value(newValue) {
      console.log('new value', newValue);
      // if(newValue) {
      //   this.selectedCurrency = this.formattedCurrencies.find(currency => currency.code === newValue);
      //   this.$emit("input", this.selectedCurrency);
      // }
      
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
/* Add any styles if necessary */
</style>
